export default "__VITE_ASSET__BjO1vHwa__"